import "bootstrap";
import * as React from "react";
import { Link } from "react-router-dom";
import getAccountName from "utils/getAccountName";
import { useAccount, useMsal } from "./common/msal";

function Header() {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [isLogginOut, setisLogginOut] = React.useState(false);

    React.useEffect(() => {
        const script = document.createElement("script");
        script.src = "../dist/app.js";
        script.async = true;
        document.body.appendChild(script);

        $(".navbar .dropdown-toggle").dropdown();
    }, []);

    if (isLogginOut) {
        return (
            <div
                style={{
                    background: "rgba(0,0,0,0.7)",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "1000",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <p style={{ color: "white" }}>Loging Out...</p>
            </div>
        );
    }

    return (
        <header className="app-header navbar">
            <div className="navbar-toggler sidebar-toggler mobile-sidebar-toggler d-lg-none">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <a className="navbar-brand" href="#"></a>

            <ul className="nav navbar-nav ml-auto">
                <li className="nav-item search-nav-item">
                    <div id="sb-search" className="sb-search">
                        <form>
                            <input
                                className="sb-search-input"
                                placeholder="Search Here"
                                type="search"
                                defaultValue=""
                                name="search"
                                id="search"
                            />
                            <input className="sb-search-submit" type="submit" value="" />
                            <Link to="/search">
                                <span className="sb-icon-search"></span>
                            </Link>
                        </form>
                    </div>
                </li>
                <li className="nav-item dropdown">

                    <a
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {getAccountName()} <i className="icon-cheveron-down-black"></i>
                    </a>

                    <div className="dropdown-menu dropdown-menu-right">
                        <Link to="/" className="dropdown-item">
                            <i className="icon-quotes-black"></i> Dashboard
                        </Link>
                        <Link
                            onClick={async () => {
                                setisLogginOut(true);
                                try {
                                    localStorage.removeItem("authorization_token");
                                    instance.logoutRedirect({ account: account });
                                    setisLogginOut(false);
                                } catch (error) {
                                    alert("Encountered error logging out");
                                    setisLogginOut(false);
                                }
                            }}
                            to="."
                            className="dropdown-item"
                        >
                            <i className="icon-logout"></i> Log out
                        </Link>
                    </div>
                </li>
            </ul>
        </header>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./ClientApp/components/Header.tsx